import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { SET_MULTI_IMAGER } from 'actions/multiImagerActionTypes'
import { setMultiImagerSelector } from 'selectors'
import { setCameraModelAction } from 'actions/cameraActions'
import { createMultiImagerLensAction, addLensIdsAction } from 'actions/multiImagerActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import chooseNextProperId from 'helpers/chooseNextProperId'

export function * setMultiImager(action) {
  try {
    const { currentCamera: { id, location, remove }, cameraIds } = yield select(setMultiImagerSelector)
    const { model: { imager_count, imager_option_ids, ptz_imager_count, ptz_imager_option_ids, multi_imager_type }, model, aov, skipRemove } = action

    // remove old markers
    if (remove && !skipRemove) yield call(remove)

    let childLensIds = []

    if (multi_imager_type === 'Repositionable' || multi_imager_type === 'Fixed') {
      const fixed = multi_imager_type === 'Fixed'
      const base = { location, imagerId: id, lensId: imager_option_ids[0], fixed }

      for (let i = 0; i < imager_count; i++) {
        childLensIds[i] = yield call(chooseNextProperId, [...cameraIds, ...childLensIds])
        yield put(createMultiImagerLensAction({ ...base, id: childLensIds[i], heading: i * 360 / imager_count, name: `Imager ${i + 1}` }))
      }

      fixed ? yield put.resolve(addLensIdsAction(id, childLensIds, childLensIds)) : yield put.resolve(addLensIdsAction(id, childLensIds))
    } else {
      const fixed = /Fixed/.test(multi_imager_type)
      const base = { location, imagerId: id, lensId: imager_option_ids[0] }
      const ptzBase = { ...base, lensId: ptz_imager_option_ids[0] }
      const imagerCount = imager_count - ptz_imager_count

      for (let i = 0; i < imagerCount; i++) {
        childLensIds[i] = yield call(chooseNextProperId, [...cameraIds, ...childLensIds])
        yield put(createMultiImagerLensAction({ ...base, id: childLensIds[i], heading: i * 360 / imagerCount, name: `Imager ${i + 1}`, fixed }))
      }
      for (let i = 0; i < ptz_imager_count; i++) {
        const childId = yield call(chooseNextProperId, [...cameraIds, ...childLensIds])
        childLensIds[imagerCount + i] = childId
        yield put(createMultiImagerLensAction({ ...ptzBase, id: childId, heading: (i + .5) * 360 / imagerCount, name: `PTZ ${i + 1}`, ptz: true }))
      }

      fixed ? yield put.resolve(addLensIdsAction(id, childLensIds, childLensIds.slice(0, imagerCount))) : yield put.resolve(addLensIdsAction(id, childLensIds))
    }

    yield put(setCameraModelAction(model, aov))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for set multi imager action, then call function */
export function * watchSetMultiImager() {
  yield * takeEvery(SET_MULTI_IMAGER, setMultiImager)
}



// WEBPACK FOOTER //
// ./src/sagas/setMultiImagerSaga.js